import React from 'react';
import { useFormContext } from 'react-hook-form';
import i18n from '../../I18n';
import CustomTitleWithInput from '../base/CustomTitleWithInput';
import { ReactHookFormMarkDown } from '../base/CustomMarkDownArea';
import { hasError, ReactHookFormErrorMessage } from '../base/ErrorFieldMessage';
import { CustomTitleLabel } from 'components/earning/CustomBaseComponments';
import CustomSwitchButton from 'components/base/CustomSwitchButton';


function CreateCustomerGroupGeneral() {
  const { watch, setValue, formState } = useFormContext();
  const { errors } = formState;

  const nameField = 'name';
  const descriptionField = 'description';
  const customerGroupName = watch(nameField);
  const showInCustomerProfile = watch('showInCustomerProfile');

  return (
    <>
      <div className="first-section-title">
        {i18n.t('general')}
      </div>
      <CustomTitleWithInput
        title={i18n.t('name')}
        error={{ error: hasError(errors, nameField) }}
        type={'text'}
        customClass={`text-input-field date-picker `}
        defaultValue={customerGroupName}
        setValue={(value) => {
          setValue(nameField, value, { shouldDirty: true, });
        }}
      />
      <ReactHookFormErrorMessage errors={errors} id={nameField} />
      <ReactHookFormMarkDown
        content={{
          label: i18n.t('description_optional'),
          key: descriptionField,
          focus: () => {},
        }}
      />
      <CustomTitleLabel title="Show in Customer profile as 'Customer tag'" />
      <CustomSwitchButton
        defaultChecked={showInCustomerProfile}
        onChange={(isChecked) => {
          setValue('showInCustomerProfile', isChecked, { shouldDirty: true });
        }}
      />
    </>
  );
}

export default CreateCustomerGroupGeneral;
